import React from 'react';
import { type TippyProps } from '@tippyjs/react';
import Tippy from '@tippyjs/react';
import { isEmpty } from 'lodash';

import './styles/tooltips.scss';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

type Props = Pick<TippyProps, 'content' | 'children'> & {
  tippyOptions?: Omit<TippyProps, 'content' | 'children'>;
};

export const TippyTooltip: React.FC<Props> = ({
  content,
  children,
  tippyOptions = {},
}) => {
  const { placement, ...restTippyProps } = tippyOptions;
  return isEmpty(content) ? (
    <>{children}</>
  ) : (
    <Tippy
      {...{
        delay: [300, 0],
        interactive: true,
        allowHTML: true,
        placement: placement ?? 'auto',
        className: 'tippy-tooltip light-theme',
        theme: 'light',
        content,
        ...restTippyProps,
      }}
    >
      {children}
    </Tippy>
  );
};
